import { ArrowBackIcon, HamburgerIcon, SettingsIcon } from "@chakra-ui/icons";
import { TbMessageCirclePlus } from "react-icons/tb";

export interface IProfileLink {
    to: string;
    localeName: string;
    createIcon: () => React.ReactElement;
}
export const PROFILE_LINKS: IProfileLink[] = [
    {
        to: '/orders',
        localeName: 'my-orders',
        createIcon: () => <HamburgerIcon boxSize={4} />
    },
    {
        to: '/support',
        localeName: 'support',
        createIcon: () => <TbMessageCirclePlus size="18px" />
    },
    {
        to: '/settings',
        localeName: 'settings',
        createIcon: () => <SettingsIcon />
    },
    {
        to: '/catalog',
        localeName: 'back-to-catalog',
        createIcon: () => <ArrowBackIcon boxSize={4} />
    }
]